<script lang="ts">
	// let requireEmail = false;
	// let component: any;
	// if (browser)
	// 	onMount(async () => {
	// 		const url = new URL('api/no-bot', env.PUBLIC_DASHBOARD_BASE_URL).toString();

	// 		const res = await to(fetch(url));
	// 		if (res.err) {
	// 			console.error('could not ensure not bot', res.err);
	// 			return;
	// 		}
	// 		if (res.data.status == 401) {
	// 			requireEmail = true;
	// 			return;
	// 		}

	// 		const qrCodeGenerator = await to(import('./QrCodeGenerator.svelte'));
	// 		if (qrCodeGenerator.err) {
	// 			console.error('could not download QRCodeGenerator');
	// 			return;
	// 		}

	// 		component = qrCodeGenerator.data.default;
	// 	});

	// let email = 'didonato.fr@gmail.com';
	// async function submitEmail(
	// 	event: SubmitEvent & {
	// 		currentTarget: EventTarget & HTMLFormElement;
	// 	}
	// ) {
	// 	const url = new URL('api/no-bot/verify', env.PUBLIC_DASHBOARD_BASE_URL);
	// 	url.searchParams.set('email', encodeURIComponent(email));
	// 	url.searchParams.set('location', encodeURIComponent('qr-code-generator'));

	// 	const res = await to(fetch(url));
	// 	if (res.err) {
	// 		console.error('could not verify not bot', res.err);
	// 		return;
	// 	}

	import { browser } from '$app/environment';
	import ColorPickerHsl, {
		getRandomHsl
	} from '$lib/components/color-pickers/ColorPickerHSL.svelte';
	import { slugify } from '$lib/utils/string';
	import Icon from '@iconify/svelte';
	// @ts-ignore
	import QRious from 'qrious';
	import colorConver from 'color-convert';
	import { onMount } from 'svelte';
	import { debounce } from '@melt-ui/svelte/internal/helpers';
	import { slide } from 'svelte/transition';
	import { createAccordion } from '@melt-ui/svelte';
	import { cn } from '$lib/utils/style.js';
	import SeoMetaTags from '$lib/components/seo/SeoMetaTags.svelte';

	export let data;
	let invalid = false;
	let value = 'https://easypagego.com/free-tools/qr-code-generator/';
	let background = colorConver.hex.hsl('#FFFFFF');
	let backgroundAlpha = 1;
	let foreground = colorConver.hex.hsl('#000000');
	let foregroundAlpha = 1;
	let canvasRef: HTMLCanvasElement;

	let w = Infinity;
	if (browser)
		onMount(() => {
			w = window.innerWidth;
			generate();
		});

	let websiteURLRef: HTMLInputElement;
	function generate() {
		const qr = new QRious({
			background: `#${colorConver.hsl.hex(background)}`,
			backgroundAlpha,
			foreground: `#${colorConver.hsl.hex(foreground)}`,
			foregroundAlpha,
			level: 'H', // L, M, Q, H
			mime: 'image/png',
			padding: 50,
			value,
			size: 4000
		});
		const img = new Image();
		img.src = qr.toDataURL();
		img.onload = function () {
			const ctx = canvasRef.getContext('2d');
			if (!ctx) throw new Error('canvas context not found');
			ctx.drawImage(img, 0, 0, canvasRef.width, canvasRef.height);
		};
	}
	const debounceGenerate = debounce(() => {
		updateValidity();
		if (invalid) return;
		generate();
	}, 300);
	function updateValidity() {
		if (!websiteURLRef.validity.valid) {
			invalid = true;
			return;
		}
		invalid = false;
	}

	function download() {
		if (invalid) return;
		const link = document.createElement('a');
		link.download = `${slugify(value)}.png`;
		link.href = canvasRef.toDataURL('image/png');
		link.click();
	}

	const {
		elements: { content, item, trigger, root },
		helpers: { isSelected }
	} = createAccordion({
		multiple: true
	});
</script>

<svelte:head>
	<SeoMetaTags
		context={data.context}
		title="Free Online QR Code Generator - Create Custom QR Codes Instantly"
		description="Easily create free QR codes online with our simple QR code generator. Download high-resolution PNG files and start using your custom QR codes in minutes—no sign-up or fees required!"
		ogTitle="Free QR Code Generator Online - Make and Download Custom QR Codes"
		ogDescription="Easily create free QR codes online with our simple QR code generator. Download high-resolution PNG files and start using your custom QR codes in minutes—no sign-up or fees required!"
		ogImage="/images/og/qr-code.png"
	/>
</svelte:head>

<svelte:window
	on:resize|passive={() => (w = window.innerWidth)}
	on:keypress={(e) => e.key == 'Enter' && download()}
/>

<main class="mt-8 container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20 px-4">
	<div class="w-full prose-sm sm:prose md:prose-lg mx-auto text-left">
		<div class="flex items-center gap-2">
			<Icon icon="material-symbols:qr-code" width="28" height="28" class="hidden sm:block" />
			<span class="badge badge-accent badge-lg font-semibold">100% FREE</span>
		</div>
		<h1 class="!my-0">Free Online QR Code Generator - Create Custom QR Codes Instantly</h1>
		<p>
			Generate free, custom QR codes online with our easy-to-use QR code generator. Create and
			download high-quality QR code PNGs instantly—perfect for business, personal use, and marketing
			needs. No sign-up required!
		</p>

		<form on:submit|preventDefault={download} class="flex flex-col gap-6">
			<div class="form-control">
				<span class="font-medium">Website URL*</span>
				<input
					bind:this={websiteURLRef}
					type="url"
					bind:value
					class="input input-bordered"
					placeholder="e.g. https://easypagego.com/free-tools/qr-code-generator/"
					on:input={debounceGenerate}
					required
				/>
				{#if invalid}
					<div transition:slide>
						<p>Are you trying to create a QR code for text?</p>
					</div>
				{/if}
			</div>

			<div {...$root} class="join join-vertical">
				<div {...$item('background')} use:item class="join-item border border-base-200">
					<button
						type="button"
						{...$trigger('background')}
						use:trigger
						class="btn btn-block btn-ghost no-animation justify-between rounded-[inherit]"
					>
						<div class="flex items-center gap-3">
							<Icon icon="fluent:color-background-20-regular" width="24" height="24" />
							<span> Change Background Color </span>
						</div>
						<Icon
							icon="ic:round-chevron-right"
							width="24"
							height="24"
							class={cn(
								'transition-transform duration-500 ease-in-out',
								$isSelected('background') ? '-rotate-180' : 'rotate-90'
							)}
						/>
					</button>
					{#if $isSelected('background')}
						<div
							{...$content('background')}
							use:content
							transition:slide
							class="flex flex-col gap-2 px-4 py-6"
						>
							<ColorPickerHsl
								name="background"
								bind:hsl={background}
								bind:alpha={backgroundAlpha}
								on:input={debounceGenerate}
							/>
							<button
								type="button"
								class="mt-2 btn btn-sm self-end"
								on:click={() => {
									background = getRandomHsl();
									if (invalid) return;
									generate();
								}}
							>
								<Icon icon="ri:dice-line" width="20" height="20" />
								<span> Random </span>
							</button>
						</div>
					{/if}
				</div>

				<div {...$item('foreground')} use:item class="join-item border border-base-200">
					<button
						type="button"
						{...$trigger('foreground')}
						use:trigger
						class="btn btn-block btn-ghost no-animation justify-between rounded-[inherit]"
					>
						<div class="flex items-center gap-3">
							<Icon icon="bitcoin-icons:qr-code-outline" width="24" height="24" />
							<span> Change QR Code Color </span>
						</div>
						<Icon
							icon="ic:round-chevron-right"
							width="24"
							height="24"
							class={cn(
								'transition-transform duration-500 ease-in-out',
								$isSelected('foreground') ? '-rotate-180' : 'rotate-90'
							)}
						/>
					</button>
					{#if $isSelected('foreground')}
						<div
							{...$content('foreground')}
							use:content
							transition:slide
							class="flex flex-col gap-2 px-4 py-6"
						>
							<ColorPickerHsl
								name="foreground"
								bind:hsl={foreground}
								bind:alpha={foregroundAlpha}
								on:input={debounceGenerate}
							/>
							<button
								type="button"
								class="mt-2 btn btn-sm self-end"
								on:click={() => {
									foreground = getRandomHsl();
									if (invalid) return;
									generate();
								}}
							>
								<Icon icon="ri:dice-line" width="20" height="20" />
								<span> Random </span>
							</button>
						</div>
					{/if}
				</div>
			</div>

			<div class="not-prose flex items-center gap-4">
				<button
					type="submit"
					class="btn btn-primary sm:self-start"
					disabled={invalid}
				>
					<Icon icon="ic:sharp-download" width="20" height="20" />
					<span>Download (FREE)</span>
					<kbd class="kbd bg-white hidden md:inline-flex">Enter</kbd>
				</button>
				<a
					href="/blog/free-qr-code-generator-online/"
					class="link link-hover link-info text-sm"
					target="_blank"
				>
					Why do I need a QR Code?
				</a>
			</div>
		</form>
	</div>
	<div class="order-first lg:order-last">
		<div class="lg:sticky lg:top-[6.5rem]">
			{#if invalid}
				<p class="text-error">Please, provide a valid Website address.</p>
			{:else}
				<div
					transition:slide={{ duration: 500 }}
					class="flex flex-col items-center justify-center gap-8"
				>
					<canvas
						bind:this={canvasRef}
						width="500"
						height="500"
						style="max-width: {Math.min(w - 20, 500)}px;"
					/>
					<div class="flex items-center gap-2">
						<Icon icon="mdi:camera" width="20" height="20" />
						<p class="text-center font-bold tracking-wide">Try me with your phone!</p>
					</div>
				</div>
			{/if}
		</div>
	</div>
</main>

<style lang="postcss">
	input {
		&:valid {
			@apply input-success;
		}
		&:invalid {
			@apply input-error;
		}
	}
</style>
